/** End-to-end exports are an explicit trial; the measured 320 default stays available. */
export function detectorExport(
  raster: string,
  backend: string,
  query: URLSearchParams,
  available: Record<string, number>,
): { file: string; note?: string } {
  const webgl = backend === "webgl";
  const normal = raster === "640" ? "detector-640" : raster === "416" ? "detector" : "detector-320";
  const fallback = `${normal}${webgl ? "-webgl" : ""}.onnx`;
  if (!query.has("detend2end")) return { file: fallback };
  const values = query.getAll("detend2end");
  const size = values[0];
  if (values.length !== 1 || (size !== "416" && size !== "640") || webgl)
    return {
      file: fallback,
      note: "detend2end requires 416 or 640 and the WebGPU/CPU backend; keeping the configured export",
    };
  const file = `detector-${size}-end2end.onnx`;
  if (!available[file])
    return { file: fallback, note: `${file} is not in this bundle; keeping the configured export` };
  return {
    file,
    note: `experimental ${file}; compare leading quads and sustained frame costs before adopting`,
  };
}
